import React from "react";

const newsList = [
  {
    'title': 'Bitcoin Surges Past $120,000 Amid ETF Inflows',
    'description': 'Bitcoin hits a new all-time high as institutional investors pour billions into spot ETFs, driving market optimism.',
    'imageUrl': 'https://images.pexels.com/photos/8370752/pexels-photo-8370752.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'Crypto Daily',
    'content': 'Bitcoin has soared past $120,000 this week, fueled by massive inflows into U.S.-based spot Bitcoin ETFs...'
  },
  {
    'title': 'USD/JPY Hits 5-Year High as Fed Signals Rate Hike',
    'description': 'The U.S. dollar strengthens against the yen, driven by expectations of tighter monetary policy from the Federal Reserve.',
    'imageUrl': 'https://images.pexels.com/photos/6802048/pexels-photo-6802048.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'Forex Insider',
    'content': 'The USD/JPY pair climbed to a five-year high of 155.20...'
  },
  {
    'title': 'XRP Gains 30% After Ripple’s Legal Victory',
    'description': 'XRP rallies following a favorable court ruling in Ripple’s case against the SEC, boosting investor confidence.',
    'imageUrl': 'https://images.pexels.com/photos/5980742/pexels-photo-5980742.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'Coin Telegraph',
    'content': 'XRP surged 30% to $2.50 after a U.S. court ruled in favor of Ripple Labs...'
  },
  {
    'title': 'Ethereum Nears $6,000 as Staking Demand Soars',
    'description': 'Ethereum’s price climbs toward a new milestone, driven by increased staking activity and DeFi growth.',
    'imageUrl': 'https://images.pexels.com/photos/844124/pexels-photo-844124.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'Blockchain Times',
    'content': 'Ethereum is approaching $6,000, fueled by a surge in staking...'
  },
  {
    'title': 'EUR/USD Slides as ECB Signals Dovish Policy Stance',
    'description': 'Euro weakens after ECB hints at prolonged low interest rates to support economic recovery.',
    'imageUrl': 'https://images.pexels.com/photos/534216/pexels-photo-534216.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'Market Pulse',
    'content': 'The EUR/USD pair dropped to 1.05, its lowest level in 2025...'
  },
  {
    'title': 'Cardano Jumps 25% on New Smart Contract Upgrades',
    'description': 'Cardano rallies after launching enhanced smart contract capabilities for DeFi developers.',
    'imageUrl': 'https://images.pexels.com/photos/730547/pexels-photo-730547.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'Crypto Chronicle',
    'content': 'Cardano’s ADA surged 25% to $3.20 following the rollout of new upgrades...'
  },
  {
    'title': 'GBP/USD Falls Below 1.30 Amid UK Economic Concerns',
    'description': 'The pound weakens as UK inflation disappoints, raising fears of slower economic growth.',
    'imageUrl': 'https://images.pexels.com/photos/4386158/pexels-photo-4386158.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'FX Street',
    'content': 'The GBP/USD pair slipped below 1.30 after UK inflation came in lower than expected...'
  },
  {
    'title': 'Solana Breaks $300 on NFT and Gaming Boom',
    'description': 'Solana soars as its ecosystem sees explosive growth in NFTs and gaming.',
    'imageUrl': 'https://images.pexels.com/photos/1714208/pexels-photo-1714208.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'CoinDesk',
    'content': 'Solana hit $300 due to rising NFT volume and gaming ecosystem expansion...'
  },
  {
    'title': 'AUD/USD Drops as China’s Economic Slowdown Weighs',
    'description': 'Australian dollar weakens as China posts weaker industrial production.',
    'imageUrl': 'https://www.shutterstock.com/image-photo/double-exposure-china-flag-on-600nw-2281294839.jpg',
    'source': 'Forex Crunch',
    'content': 'The AUD/USD pair fell to 0.67 as China reported weaker output numbers...'
  },
  {
    'title': 'Polkadot Gains 20% on Cross-Chain Integration News',
    'description': 'Polkadot rises after new cross-chain partnership announcements.',
    'imageUrl': 'https://images.pexels.com/photos/843700/pexels-photo-843700.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'Crypto Briefing',
    'content': 'Polkadot’s DOT climbed 20% following new Ethereum & Cosmos integrations...'
  },

  // ---- SECOND LIST (CHEDAN'S NEWS) ADDING BELOW ----

  {
    'title': 'BSE Sensex Trades Flat as Investors Await Fed Policy Decision',
    'description': 'Markets trade narrow range; Sensex down 21 points at 81,883.',
    'imageUrl': 'https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'Business Standard',
    'content': 'Sensex closed flat as investors awaited US Fed policy outcome...'
  },
  {
    'title': 'Railway Stocks Rally Up to 8% on Major Order Wins',
    'description': 'RVNL, Ircon & Texmaco Rail surge sharply on fresh contracts.',
    'imageUrl': 'https://images.pexels.com/photos/590478/pexels-photo-590478.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'MoneyControl',
    'content': 'Rail stocks outperformed after major order wins worth hundreds of crores...'
  },
  {
    'title': 'Godawari Power Hits 52-Week High, Gains 8.65%',
    'description': 'Steel and power stock surges on strong performance.',
    'imageUrl': 'https://images.pexels.com/photos/2850289/pexels-photo-2850289.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'MoneyControl',
    'content': 'Godawari Power touched 52-week high due to strong industrial demand...'
  },
  {
    'title': 'Realty Sector Leads Gains as Nifty Realty Jumps 0.92%',
    'description': 'Realty stocks outperform on festive demand expectations.',
    'imageUrl': 'https://images.pexels.com/photos/280229/pexels-photo-280229.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'Business Standard',
    'content': 'Nifty Realty outperformed driven by festive season property demand...'
  },
  {
    'title': 'IT Stocks Drag Markets Lower, Nifty IT Falls 0.74%',
    'description': 'Infosys, TCS decline as global uncertainty impacts IT demand.',
    'imageUrl': 'https://images.pexels.com/photos/577585/pexels-photo-577585.jpeg?auto=compress&cs=tinysrgb&w=800&h=400',
    'source': 'Business Standard',
    'content': 'Infosys fell 1.32%, TCS down 1.5% dragging Nifty IT index lower...'
  },

  // ... (Bhai remaining items bhi isi format me add karte jao)
];

const News = () => {
  return (
    <div className="container-fluid">
      
      <div className="card">
        <div className="card-header">
          <div className="card-title fw-bold fs-5">News</div>
        </div>

        <div className="card-body">

          <div className="row g-4">

            {newsList.map((item, index) => (
              <div className="col-md-4 col-sm-6" key={index}>
                
                <div
                  className="shadow-sm"
                  style={{
                    borderRadius: "12px",
                    background: "#fff",
                    border: "1px solid #e8e8e8",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    cursor: "pointer"
                  }}
                >

                  {/* IMAGE */}
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    style={{
                      width: "100%",
                      height: "160px",
                      objectFit: "cover",
                    }}
                  />

                  {/* CONTENT */}
                  <div className="p-3">
                    <h6 className="fw-bold" style={{ fontSize: "15px" }}>
                      {item.title}
                    </h6>

                    <p className="text-muted" style={{ fontSize: "13px" }}>
                      {item.description}
                    </p>

                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <small
                        className="text-primary fw-semibold"
                        style={{ fontSize: "12px" }}
                      >
                        {item.source}
                      </small>

                      <button
                        className="btn btn-sm"
                        style={{
                          background: "#084abb",
                          color: "#fff",
                          fontSize: "12px",
                          padding: "4px 10px",
                          borderRadius: "6px",
                        }}
                      >
                        Read
                      </button>
                    </div>

                  </div>
                </div>

              </div>
            ))}

          </div>

        </div>
      </div>

    </div>
  );
};

export default News;
